import { FaGraduationCap, FaPlayCircle } from "react-icons/fa";
import NavLinks from "../../Prompt/NavLink";
import { Link, useNavigate } from "react-router-dom";
import useAuth from "../../../Hooks/useAuth";
import { logout } from "../../../Utility/service";
import React, { useContext, useEffect, useState } from "react";
import { ThemeContext } from "../../../contexts/themeConfig";
import "./AssistantListPinIcon.css"
import { CgProfile } from "react-icons/cg";
import { FaSync } from "react-icons/fa";
import { RiBug2Fill, RiGraduationCapFill, RiLogoutCircleLine } from "react-icons/ri";
import { MdBrowserUpdated } from "react-icons/md"
import { axiosSecureInstance } from "../../../api/axios";
import { Badge, Space, notification } from "antd";
import { getUserID } from "../../../Utility/service";
import { HiAcademicCap } from "react-icons/hi2";
import { IoDocumentText } from "react-icons/io5";
import { useTour } from "../../../Utility/walkthrough/useTour";
const userId = getUserID();
const TUTORIAL_LEADSLIFT_URL =
  "https://docs.google.com/document/d/1McErUX9EPKh-I08uRPp8iwLFW78Ej7fBicn0fJtoRgQ/edit?tab=t.powvmwjcec9p";
const ACADEMY_URL = "https://academy.collabai.software/"
const CommonNavLinks = () => {
  const { theme } = useContext(ThemeContext);
  const navigate = useNavigate();
  const { setAuth } = useAuth();
  const [badgeVisible, setBadgeVisible] = useState(false);
  const { startTour } = useTour();

  const getPushNotifications = async () => {
    const response = await axiosSecureInstance.get(`api/notify-badge/${userId}`);
    return response;

  }

  useEffect(() => {
    getPushNotifications().then(getNotify => {
      if (getNotify?.data) {
        setBadgeVisible(getNotify?.data?.badgeVisible);
        if (getNotify?.data?.badgeVisible) {
          notification.open({
            message: 'We’ve introduced new features / fixed a few pesky bugs. Check out the updates in the “ChangeLog” menu on the left side',
            placement: 'topRight',
            duration: null,
            style: {
              backgroundColor: '#72BF78',
              border: '1px solid #6697cc',
            },
          });
        }
      }
    })


  }, []);

  // 2. Hide the badge on click
  const handleClick = async () => {
    const body = { showBadge: false }
    const addNotification = await axiosSecureInstance.patch(`api/notify-badge/${userId}`, body);
    if (addNotification.data.status === 'ok') {
      setBadgeVisible(false);
    }
  };
  const handleLogout = () => {
    localStorage.removeItem("planAlertDismissed");
    setAuth({
      role: "",
      loggedIn: false,
    });
    logout();
    navigate("/login", { replace: true });
  };
  return (
    <div className="sidebar-bottom-section">
      {/* 
      <NavLinks
        svg={<FaSync size={22}  />
      }
        text="Sync Applications"
        link="/integrate-apps"
      /> */}






      {/* {badgeVisible && (
        <span
          style={{
            display: 'inline-block',
            marginLeft: '6px',
            width: '8px',
            height: '8px',
            backgroundColor: 'red',
            borderRadius: '50%',
          }}
        />
      )} */}

    </div>
  );
};

export default CommonNavLinks;
